import { render, staticRenderFns } from "./NewDeal.vue?vue&type=template&id=0b7ec6ca&scoped=true"
import script from "./NewDeal.vue?vue&type=script&lang=js"
export * from "./NewDeal.vue?vue&type=script&lang=js"
import "./NewDeal.vue?vue&type=style&index=0&id=0b7ec6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ec6ca",
  null
  
)

export default component.exports